export default {
  jobs: [],
  lastUpdated: 0,
  fetching: false,
  adding: false,
  jobTypesBeingAdded: new Set(),
  archiveJobs: [],
};
